import { Observable } from 'rxjs';

import { EFFECT } from './constants';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isEffect(effect: any): effect is () => Observable<unknown> | void {
  return effect[EFFECT];
}
